import { Box, Group, Skeleton } from '@mantine/core';
import { SettingsButton } from '@repo/common/components';
import { Suspense } from 'react';
import { FilterOptionType } from '../../../../../packages/common/components/Filter/types';
import { useSuspenseFeatureAccess } from '../../api';
import { ErrorBoundary } from '../../components/ErrorBoundary';
import { FILTER_OPTIONS_CONFIG } from '../../components/Filter/constants';
import { PIIWordsList } from '../../components/Settings/PIIWordsList';
import { UpgradeButton } from '../../components/Settings/UpgradeButton';
import { TableV2 } from '../../components/TableV2';
import type { IPII } from './PIITableV2.hooks';
import { useActions, useColumns, usePiiList } from './PIITableV2.hooks';

const QUICK_ACTIONS = ['actions::apply_pii'] as const;

export function PIITableV2() {
	const { piiAccess } = useSuspenseFeatureAccess();
	const columns = useColumns();
	const actions = useActions();

	const PAGINATION_LIST_OPTIONS = {
		suspense: true,
	};

	return (
		<Box>
			<ErrorBoundary>
				<Suspense fallback={<Skeleton h="70vh" w="100%" />}>
					<Box>
						<SettingsButton
							title="PII columns"
							description="Data marked as PII can only be viewed by admins and editors"
						>
							{piiAccess ? (
								<Group>
									<PIIWordsList />
								</Group>
							) : (
								<UpgradeButton feature="PII Table" />
							)}
						</SettingsButton>
					</Box>

					<Box my="lg" />

					{piiAccess && (
						<TableV2<IPII>
							pluralTypeString="piis"
							tableCacheKey="piis"
							columns={columns}
							usePaginationList={usePiiList}
							usePaginationListOptions={PAGINATION_LIST_OPTIONS}
							withCheckbox={true}
							withActions={actions}
							withSearch
							defaultSort={null}
							withFilterOptions={[
								FILTER_OPTIONS_CONFIG[FilterOptionType.TABLE],
								FILTER_OPTIONS_CONFIG[FilterOptionType.DATABASE],
								FILTER_OPTIONS_CONFIG[FilterOptionType.SCHEMA],
								FILTER_OPTIONS_CONFIG[FilterOptionType.INTEGRATION],
							]}
							withQuickActions={QUICK_ACTIONS}
							noRecordsText="No tables with PII data found"
						/>
					)}
				</Suspense>
			</ErrorBoundary>
		</Box>
	);
}
